module.exports = __webpack_public_path__ + "static/media/1POLICY20.66e3fcd9.jpg";